import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { PAGE_STORES } from '../pages/stores';

export default function useStore<T>(store: PAGE_STORES): T {
  const { pages } = useContext(MobXProviderContext);
  return pages[store];
}
